import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { FLYER_SELL_PHOTOS_FACE_REC_OFF_FIND_STEP_COPY } from '../../../constants';

const propTypes = {
  albumFolder: PropTypes.shape({
    onboarding_type: PropTypes.string,
  }).isRequired,
  step2Top: PropTypes.string.isRequired,
  step3Top: PropTypes.string.isRequired,
};

const FlyerPrintTemplateSellPhotosFaceRecOffSteps = ({
  albumFolder,
  step2Top,
  step3Top,
}) => {
  const findStepCopy =
    FLYER_SELL_PHOTOS_FACE_REC_OFF_FIND_STEP_COPY[
      albumFolder.onboarding_type
    ] ?? FLYER_SELL_PHOTOS_FACE_REC_OFF_FIND_STEP_COPY.DEFAULT;

  return (
    <Fragment>
      <p
        className="marketing-material-flyer-sell-photos-face-rec-off-step"
        style={{ top: step2Top }}
      >
        {findStepCopy}
      </p>
      <p
        className="marketing-material-flyer-sell-photos-face-rec-off-step"
        style={{ top: step3Top }}
      >
        Waldo will text you proofs!
      </p>
    </Fragment>
  );
};

FlyerPrintTemplateSellPhotosFaceRecOffSteps.propTypes = propTypes;

export default FlyerPrintTemplateSellPhotosFaceRecOffSteps;
